export default {
  name: 'Documents',

  render(h) {
    return h('router-view')
  }
}
